// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '../environmentConfig';

export const config: EnvironmentConfig = {
  production: true,
  kknowContentApi: 'https://kaikai-now-admin.sg.cosmose.co/kaikai-now-content-api/v1',
  kknowTargetingApi: 'https://targeting.kaikai-now.sg.cosmose.co/v1',
  apiRoot: 'https://api.jp.cosmose.co/uaa',
  mindBrushApi: 'https://mindbrush-pub.sg.cosmose.co',
  kknowAdminApi: 'https://kaikai-now-admin.sg.cosmose.co',
  apiKey: 'a2Fpa2FpLW5vdy1hZG1pbjpyaXcwMU15ckd6R0JuMDg=',
  prefix: 'Bearer',
};
